module.exports = __webpack_public_path__ + "static/media/banner_purple_bg.dbeb6471.jpeg";